
import Logo from '../../img/Logo-Windo.png';
import { AiOutlineMail } from 'react-icons/ai';
import { SlLocationPin } from 'react-icons/sl';
import { MdOutlineLocalPhone } from 'react-icons/md';
import { FaViber } from 'react-icons/fa';
import { RiTelegramLine } from 'react-icons/ri';
import { AiOutlineInstagram } from 'react-icons/ai';
import { PiTiktokLogo } from "react-icons/pi";
import { BoxContacts, FooterContactBox, ContainerFooter, ContainerSoc, EndText, FooterBoxContacts, IndividualContact, IndividualLink, LinkSocial, LogoFooter, SocialFooterContainer, TextContacts, ViberTelegramBox } from './Footer.styled';
import { iconSize } from '../../constants/iconSize';

const Footer = () => {
    return (
        <ContainerFooter>
            <FooterBoxContacts>
                <LogoFooter src={Logo} alt="logo" />
                <FooterContactBox>
                    <div>
                        <BoxContacts>
                            <AiOutlineMail size={iconSize.md}/> <TextContacts>windo1@ukr.net</TextContacts>  
                        </BoxContacts>
                        <BoxContacts>
                        <SlLocationPin size={iconSize.md}/> <TextContacts>м. Чернівці</TextContacts>  
                        </BoxContacts>
                    </div>
                    <div>
                        <BoxContacts>
                            <MdOutlineLocalPhone size={iconSize.md}/> <TextContacts>+38 (099) 230 90 18</TextContacts>  
                        </BoxContacts>
                        <BoxContacts>
                            <MdOutlineLocalPhone size={iconSize.md}/> <TextContacts>+38 (096) 226 83 39</TextContacts>  
                        </BoxContacts>
                    </div>
                </FooterContactBox>
            </FooterBoxContacts>
            <ContainerSoc>
                <ViberTelegramBox>
                    <IndividualContact>
                        <IndividualLink href="viber://add?number=380992309018"><FaViber size={iconSize.md} color={'var(--brand-orange)'} />Viber</IndividualLink>
                    </IndividualContact>
                    <IndividualContact>
                        <IndividualLink href="tg://resolve?domain=windo_chernivtsi" target="blank_"><RiTelegramLine size={iconSize.md} color={'var(--brand-orange)'} />Telegram</IndividualLink>
                    </IndividualContact>
                </ViberTelegramBox>
                <SocialFooterContainer>
                    <LinkSocial href="https://www.tiktok.com/@windo41?_t=8l4sR9xFZNG" target="blank_"><PiTiktokLogo size={iconSize.md} /></LinkSocial>
                    <LinkSocial href="https://www.instagram.com/windo_ua/" target="blank_"><AiOutlineInstagram size={iconSize.md}/></LinkSocial>
                </SocialFooterContainer>
            </ContainerSoc>
            <EndText>Win.Do © 2023 Всі права захищені</EndText>
        </ContainerFooter>
    )
};

export default Footer;
